module.exports = __webpack_public_path__ + "img/icon-facebook.70d31d74.svg";